import { marketPlaceApi } from 'api'

interface TenantShortDTO {
  description: string
  id: string
  name: string
}

export const fetchApplicationTenantsApi = () => marketPlaceApi.get<TenantShortDTO[]>('/applications/tenants')
